import { useParams } from 'react-router-dom'
import ClientPage from './[id]/ClientPage'

export default function CandidateDetailPage() {
  const { id } = useParams<{ id: string }>()
  
  if (!id) {
    return <div>Candidate ID not found</div>
  }
  
  return <ClientPage params={{ id }} />
}